import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const SNACKBAR_DEFAULTS: MatSnackBarConfig = {
  duration: 3000,
  horizontalPosition: 'right',
  verticalPosition: 'bottom',
};
